import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND}/api`;

// ---------- Token storage (Bearer-token fallback for environments where
// httpOnly cookies are stripped by a reverse proxy) ----------
const TOKEN_KEY = "dpial_access_token";

export function getStoredToken() {
  // sessionStorage can throw in private-mode / sandboxed iframes — non-fatal.
  try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setStoredToken(token) {
  try { if (token) sessionStorage.setItem(TOKEN_KEY, token); } catch { /* storage unavailable */ }
}
export function clearStoredToken() {
  try { sessionStorage.removeItem(TOKEN_KEY); } catch { /* storage unavailable */ }
}

export const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the Bearer token (if stored) to every request as a fallback.
// The backend reads cookie first; if absent, reads Authorization header.
apiClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token && !config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
